export function set_alerts(state, payload) {
	state.alerts = payload;
}

export function clear_alerts(state) {
	state.alerts = [];
}
